import { SellingPlan } from './selling-plan'
import { SellingPlanGroup } from './selling-plan-group'
import { DiscountType, PriceAdjustment } from './price-adjustments'
import { Product } from './product'
import { Variant } from './variant'
import { SellingPlanAllocation } from './selling-plan-allocation'

const getPriceAdjustment = (valueType: DiscountType, value: number): PriceAdjustment => {
  return {
    valueType: valueType,
    value: value
  }
}

const getSellingPlan = (id: number,
  name: string,
  groupId: string,
  groupName: string,
  variants: Variant[],
  dummyPriceAdjustment: PriceAdjustment[]): SellingPlan => {
  return {
    id,
    name,
    description: '',
    options: [
      {
        name: groupName,
        position: 1,
        value: name
      }
    ],
    priceAdjustments: dummyPriceAdjustment
  }
}

const getSellingPlanGroup = (id: string,
  name: string,
  sellingPlans: SellingPlan[],
  variants: Variant[],
  position: number): SellingPlanGroup => {
  return {
    id,
    name,
    options: [
      {
        name,
        position: position,
        values: sellingPlans.map(p => p.name)
      }
    ],
    sellingPlans: sellingPlans
  }
}

const getSellingPlanAllocations = (groupId: string, sellingPlanId: number, price: number) => {
  return {
    groupId: groupId,
    sellingPlanId: sellingPlanId,
    price: price
  }
}

const getVariant = (id: number, title: string, price: number, sellingPlanAllocations: SellingPlanAllocation[]) => {
  return {
    id: id,
    title: title,
    price: price,
    sellingPlanAllocations: sellingPlanAllocations
  }
}

const getProduct = (id: number,
  title: string,
  price: number,
  handle: string,
  description: string,
  requiresSellingPlan: boolean,
  variants: Variant[],
  sellingPlanGroups: SellingPlanGroup[]): Product => {
  return {
    id: id,
    title: title,
    price: price,
    handle: handle,
    description: description,
    requiresSellingPlan: requiresSellingPlan,
    variants: variants,
    sellingPlanGroups: sellingPlanGroups,
    priceVaries: false
  }
}

const dummyProductPrice = 1699

const dummyGroupName = 'Subscribe to Save'

const dummyPriceAdjustment0: PriceAdjustment[] = []

const dummyPriceAdjustment1: PriceAdjustment[] = [
  getPriceAdjustment('fixed_amount', 500)
]

const dummyPriceAdjustment2: PriceAdjustment[] = [
  getPriceAdjustment('fixed_amount', 1500)
]

const dummyPriceAdjustment3: PriceAdjustment[] = [
  getPriceAdjustment('percentage', 20)
]

const dummySellingPlanAllocations: SellingPlanAllocation[] = [
  getSellingPlanAllocations('12345', 111, 0),
  getSellingPlanAllocations('12345', 112, 999),
  getSellingPlanAllocations('12345', 113, 799),
  getSellingPlanAllocations('12345', 114, 1199)
]

const dummyVariants = (): Variant[] => {
  return [getVariant(12345, 'someTitle', dummyProductPrice, dummySellingPlanAllocations)]
}

const dummySellingPlans: SellingPlan[] = [
  getSellingPlan(111, 'Every week', '12345', dummyGroupName, dummyVariants(), dummyPriceAdjustment0),
  getSellingPlan(112, 'Every 2 weeks', '12345', dummyGroupName, dummyVariants(), dummyPriceAdjustment2),
  getSellingPlan(113, 'Every 3 weeks', '12345', dummyGroupName, dummyVariants(), dummyPriceAdjustment1),
  getSellingPlan(114, 'Every 4 weeks', '12345', dummyGroupName, dummyVariants(), dummyPriceAdjustment3)
]

const dummyGroup1 = getSellingPlanGroup('12345', dummyGroupName, dummySellingPlans, dummyVariants(), 1)

const dummySellingGroups: SellingPlanGroup[] = [
  dummyGroup1
]

export const getDummyProduct = () => {
  return getProduct(
    1,
    'Nike pro',
    dummyProductPrice,
    'nike',
    'Nice',
    false,
    dummyVariants(),
    dummySellingGroups
  )
}
